import React, {Component} from "react";
import { List, Avatar, Dropdown, Modal, Form, Button, Input, message, Select,notification} from "antd";
import {Link} from "react-router-dom";
import {withRouter} from 'react-router';

import memoryUtils from "../../utils/memoryUtils";
import './index.less'
import {
    reqCurrent, reqDeleteMsg,
    reqDepartmentList,
    reqEditTeacher,
    reqLogOut, reqMsgList, reqReadMsg,
    reqEditadmin, reqEditAdminPwd, reqGetCode,reqPwdTeacher
} from "../../api";
import storageUtils from "../../utils/storageUtils";
import * as moment from "moment";

class PasswdForm extends Component {
    state = {
        currentUser: {},
    };
    getForm1Value = () => {    //3、自定义方法，用来传递数据（需要在父组件中调用获取数据）
        let flag = false;
        this.props.form.validateFields((err, values) => {
            if (!err) {
                flag = true;
            }
        });
        if (flag) {
            // const user = this.state.currentUser;
            const obj = this.props.form.getFieldsValue();       //4、getFieldsValue：获取一组输入控件的值，如不传入参数，则获取全部组件的值
            // user.passwd = obj["confirm"];
            // return (user);
            return(obj);
        }
    };
    getCurrentUser = async () => {
        const result = await reqCurrent();
        this.setState({
            currentUser: result.data
        });
    };
    /* handleChange = (event) => {
        event.persist();
        let value = event.target.value;
        if (value === this.state.currentUser.passwd) {
            this.setState({
                validateStatus: 'success',
                errorMsg: null,
            })
        } else {
            this.setState({
                validateStatus: 'error',
                errorMsg: '旧密码输入有误',
            })
        }
    }; */
    compareToFirstPassword = (rule, value, callback) => {
        const {form} = this.props;
        if (value && value !== form.getFieldValue('newPwd')) {
            callback('两次密码输入不一致!');
        } else {
            callback();
        }
    };
    validateToNextPassword = (rule, value, callback) => {
        const {form} = this.props;
        if (value && this.state.confirmDirty) {
            form.validateFields(['confirm'], {force: true});
        }
        callback();
    };
    handleConfirmBlur = e => {
        const {value} = e.target;
        this.setState({confirmDirty: this.state.confirmDirty || !!value});
    };
    componentDidMount = async () => {
        this.getCurrentUser();
    };

    render() {
        const {getFieldDecorator} = this.props.form;
        const {validateStatus, errorMsg, currentUser} = this.state;
        return (
            <Form>
                <Form.Item
                    label="旧密码"
                    validateStatus={validateStatus}
                    help={errorMsg}>
                    {getFieldDecorator('oldPwd', {
                        validate: [
                            // 在onBlur时，触发两个对象中的规则
                            /* {
                                trigger: "onBlur",
                                rules: [
                                    {
                                        required: true,
                                        message: '请输入旧密码!',
                                    },
                                ]
                            }, */
                        ],
                    })(<Input.Password autoComplete={"off"} visibilityToggle={false} />)}
                </Form.Item>
                <Form.Item label="新密码">
                    {getFieldDecorator('newPwd', {
                        rules: [
                            {
                                required: true,
                                message: '请输入新密码!',
                            },
                            {
                                validator: this.validateToNextPassword,
                            },
                        ],
                    })(<Input.Password autoComplete={"off"} visibilityToggle={false} placeholder={"请输入新密码......"}/>)}
                </Form.Item>
                <Form.Item label="确认新密码">
                    {getFieldDecorator('confirm', {
                        validate: [
                            // 在onBlur时，触发两个对象中的规则
                            {
                                trigger: "onBlur",
                                rules: [
                                    {
                                        required: true,
                                        message: '请确认新密码!',
                                    },
                                    {
                                        validator: this.compareToFirstPassword,
                                    },
                                ],
                            },
                        ],
                    })(<Input.Password autoComplete={"off"} onBlur={this.handleConfirmBlur} visibilityToggle={false} placeholder={"请确认新密码......"}/>)}
                </Form.Item>
            </Form>
        )
    }
}

class InfoForm extends Component {
    state = {
        currentUser: {},
        page: 1,
        size: 10,
        departmentList: [],
        selectValue: '',
    };
    getForm2Value = () => {    //3、自定义方法，用来传递数据（需要在父组件中调用获取数据）
        let flag = false;
        this.props.form.validateFields((err, values) => {
            if (!err) {
                flag = true;
            }
        });
        if (flag) {
            const obj = this.props.form.getFieldsValue();
            return (obj);
        }
    };
    selectChange = e => {
        this.setState({
            selectValue: e
        })
    };
    getCurrentUser = async () => {
        const result = await reqCurrent();
        this.setState({
            currentUser: result.data
        });
    };
    getDepartmentList = async (page, size) => {
        const result = await reqDepartmentList(page, size);
        if (result.code === '000000') {
            this.setState({
                departmentList: result.data.rows
            })
        } else {
            message.error(result.msg);
        }
    };
    componentDidMount = async () => {
        this.getCurrentUser();
        this.getDepartmentList({
            page: 1,
            size: 10
        });
    };

    render() {
        const {getFieldDecorator} = this.props.form;
        const {currentUser} = this.state;
        return (
            <Form>
                <Form.Item hidden>
                    {getFieldDecorator('id', {
                        initialValue: currentUser.id,
                    })(<Input hidden/>)}
                </Form.Item>
                <Form.Item label="用户名">
                    {getFieldDecorator('userName', {
                        initialValue: currentUser.userName
                    })(<span className="ant-form-text">{currentUser.userName}</span>)}

                </Form.Item>
                <Form.Item label="真实姓名">
                    {getFieldDecorator('name', {
                        rules: [{required: true, message: '请输入真实姓名!'}],
                        initialValue: currentUser.name
                    })(<Input placeholder={"请输入真实姓名"} style={{width: '100%'}}/>)}
                </Form.Item>
                <Form.Item label="学校">
                    <span className="ant-form-text">{currentUser.schoolName}</span>
                </Form.Item>
                <Form.Item hidden>
                    {getFieldDecorator('departmentId', {
                        initialValue: currentUser.departmentId,
                    })(<Input hidden/>)}
                </Form.Item>
                <Form.Item label="院/系">
                    <span className="ant-form-text">{currentUser.departmentName}</span>
                </Form.Item>
                <Form.Item label="手机号">
                    {getFieldDecorator('mobile', {
                        validate: [
                            // 在onBlur时，触发两个对象中的规则
                            {
                                trigger: "onBlur",
                                rules: [
                                    {
                                        required: true,
                                        message: '请输入手机号'
                                    }, {
                                        pattern: /^1[3|4|5|7|8][0-9]\d{8}$/,
                                        message: '请输入正确的手机号'
                                    }
                                ],
                            },
                        ],
                        initialValue: currentUser.mobile
                    })(<Input placeholder={"请输入手机号"} style={{width: '100%'}}/>)}
                </Form.Item>
                <Form.Item label="邮箱">
                    {getFieldDecorator('email', {
                        validate: [
                            // 在onBlur时，触发两个对象中的规则
                            {
                                trigger: "onBlur",
                                rules: [
                                    {
                                        type: 'email',
                                        message: '邮箱格式错误',
                                    },
                                    {
                                        required: true,
                                        message: '请输入邮箱',
                                    },
                                ],
                            },
                        ],
                        initialValue: currentUser.email
                    })(<Input placeholder={"请输入邮箱"}/>)}
                </Form.Item>
            </Form>
        )
    }
}

class AdminForm extends Component {
    state = {
        currentUser: {},
        page: 1,
        size: 10,
        departmentList: [],
        selectValue: '',
    };
    getForm3Value = () => {    //3、自定义方法，用来传递数据（需要在父组件中调用获取数据）
        let flag = false;
        this.props.form.validateFields((err, values) => {
            if (!err) {
                flag = true;
            }
        });
        if (flag) {
            const obj = this.props.form.getFieldsValue();
            return (obj);
        }
    };
    selectChange = e => {
        this.setState({
            selectValue: e
        })
    };
    getCurrentUser = async () => {
        const result = await reqCurrent();
        this.setState({
            currentUser: result.data
        });
    };
    /* getDepartmentList = async (page, size) => {
        const result = await reqDepartmentList(page, size);
        if (result.code === '000000') {
            this.setState({
                departmentList: result.data.rows
            })
        } else {
            message.error(result.msg);
        }
    }; */
    componentDidMount = async () => {
        this.getCurrentUser();
        /* this.getDepartmentList({
            page: 1,
            size: 10
        }); */
    };

    getCode = async () => {
        const result = await reqGetCode();
        if (result.code === '000000') {
            notification.success({
                message: '授权码已发送到您的原始邮箱，请检查（授权码在您退出登录之前可反复使用，无需重复获取）',
            })
        }
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        const { currentUser } = this.state;
        return (
            <Form>
                <Form.Item hidden>
                    {getFieldDecorator('id', {
                        initialValue: currentUser.id,
                    })(<Input hidden />)}
                </Form.Item>
                <Form.Item label="用户名">
                    {getFieldDecorator('userName', {
                        rules: [{ required: true, message: '请输入用户名!' }],
                        initialValue: currentUser.userName
                    })(<Input placeholder={"请输入用户名"} style={{ width: '100%' }} />)}

                </Form.Item>

                <Form.Item label="真实姓名">
                    {getFieldDecorator('name', {
                        rules: [{ required: true, message: '请输入真实姓名!' }],
                        initialValue: currentUser.name
                    })(<Input placeholder={"请输入真实姓名"} style={{ width: '100%' }} />)}
                </Form.Item>
                {/* <Form.Item label="手机号">
                    {getFieldDecorator('mobile', {
                        initialValue: currentUser.mobile
                    })(<Input placeholder={"请输入手机号"} style={{ width: '100%' }} />)}
                </Form.Item> */}
                <Form.Item label="手机号">
                    {getFieldDecorator('mobile', {
                        validate: [
                            // 在onBlur时，触发两个对象中的规则
                            {
                                trigger: "onBlur",
                                rules: [
                                    {
                                        required: true,
                                        message: '请输入手机号'
                                    }, {
                                        pattern: /^1[3|4|5|7|8][0-9]\d{8}$/,
                                        message: '请输入正确的手机号'
                                    }
                                ],
                            },
                        ],
                        initialValue: currentUser.mobile
                    })(<Input placeholder={"请输入手机号"} style={{width: '100%'}}/>)}
                </Form.Item>
                <Form.Item label="邮箱">
                    {getFieldDecorator('email', {
                        validate: [
                            // 在onBlur时，触发两个对象中的规则
                            {
                                trigger: "onBlur",
                                rules: [
                                    {
                                        type: 'email',
                                        message: '邮箱格式错误',
                                    },
                                    {
                                        required: true,
                                        message: '请输入邮箱',
                                    },
                                ],
                            },
                        ],
                        initialValue: currentUser.email
                    })(<Input placeholder={"请输入邮箱"} />)}
                </Form.Item>
                <Form.Item label="授权码">
                    {getFieldDecorator('code', {
                        rules: [{ required: true, message: '请获取授权码!' }],
                        initialValue: currentUser.code
                    })(<Input autoComplete={"off"} placeholder={"请输入授权码"} style={{ width: '100%' }} />)}
                </Form.Item>
                <Form.Item >
                    <Button className="code_button" type="primary" onClick={this.getCode}>获取</Button>
                </Form.Item>
            </Form>
        )
    }
}

class AdminPwdForm extends Component {
    state = {
        currentUser: {},
    };

    getCode = async () => {
        const result = await reqGetCode();
        if (result.code === '000000') {
            notification.success({
                message: '授权码已发送到您的原始邮箱，请检查（授权码在您退出登录之前可反复使用，无需重复获取）',
            })
        }
    }

    getForm4Value = () => {    //3、自定义方法，用来传递数据（需要在父组件中调用获取数据）
        let flag = false;
        this.props.form.validateFields((err, values) => {
            if (!err) {
                flag = true;
            }
        });
        if (flag) {
            const obj = this.props.form.getFieldsValue();
            return (obj);
        }
    };
    getCurrentUser = async () => {
        const result = await reqCurrent();
        this.setState({
            currentUser: result.data
        });
    };

    compareToFirstPassword = (rule, value, callback) => {
        const { form } = this.props;
        if (value && value !== form.getFieldValue('pwd')) {
            callback('两次密码输入不一致!');
        } else {
            callback();
        }
    };
    validateToNextPassword = (rule, value, callback) => {
        const { form } = this.props;
        if (value && this.state.confirmDirty) {
            form.validateFields(['confirm'], { force: true });
        }
        callback();
    };
    handleConfirmBlur = e => {
        const { value } = e.target;
        this.setState({ confirmDirty: this.state.confirmDirty || !!value });
    };
    componentDidMount = async () => {
        this.getCurrentUser();
    };

    render() {
        const { getFieldDecorator } = this.props.form;
        const { validateStatus, errorMsg, currentUser } = this.state;
        return (
            <Form>
                {/* <Form.Item
                    label="旧密码"
                    validateStatus={validateStatus}
                    help={errorMsg}>
                    {getFieldDecorator('oldPwd')(<Input.Password visibilityToggle={false} autoComplete={"off"} className='pass_input' placeholder={"请输入旧密码......"} />)}
                </Form.Item> */}
                <Form.Item label="新密码">
                    {getFieldDecorator('pwd', {
                        rules: [
                            {
                                validator: this.validateToNextPassword,
                            },
                            { required: true, message: '请输入新密码' },
                            { min: 6, max: 20, message: '密码长度在6-20位' }
                        ],
                    })(<Input.Password autoComplete={"off"} visibilityToggle={false} className='pass_input' placeholder={"请输入新密码......"} />)}
                </Form.Item>
                <Form.Item label="确认新密码">
                    {getFieldDecorator('confirm', {
                        validate: [
                            // 在onBlur时，触发两个对象中的规则
                            {
                                trigger: "onChange",
                                rules: [
                                    {
                                        validator: this.compareToFirstPassword,
                                    },
                                    { required: true, message: '请确认新密码' },
                                    { min: 6, max: 20, message: '密码长度在6-20位' }
                                ],
                            },
                        ],
                    })(<Input.Password autoComplete={"off"} onBlur={this.handleConfirmBlur} visibilityToggle={false} className='pass_input' placeholder={"请确认新密码......"} />)}
                </Form.Item>
                <Form.Item label="授权码">
                    {getFieldDecorator('code', {
                        rules: [{ required: true, message: '请获取授权码!' }],
                        initialValue: currentUser.code
                    })(<Input autoComplete={"off"} placeholder={"请输入授权码"} style={{ width: '100%' }} />)}
                </Form.Item>
                <Form.Item >
                    <Button className="code_button" type="primary" onClick={this.getCode}>获取</Button>
                </Form.Item>
            </Form>
        )
    }
}

const Form1 = Form.create()(PasswdForm);
const Form2 = Form.create()(InfoForm);
const Form3 = Form.create()(AdminForm);
const Form4 = Form.create()(AdminPwdForm);

/**
 * 主页的头部组件
 */
export class Header extends Component {

    state = {
        authority: "",
        open: false,
        open1: false,
        ModalText: '',
        ModalText1: '',
        confirmLoading: false,
        teacher: {},
        disable: false,
        disable22: false,
        currentUser: {},
        InfoText: '',
        InfoText1: '',
        page: 1,
        size: 10,
        did: 1,
        user: {},
        messageList: [],
        count: 0,
    };

    logOut = async () => {
        let type = sessionStorage.getItem("testing");
        if (type==="ing") {   //处于当前页面
            sessionStorage.setItem("leavePage","none");
            document.getElementById("submit").click();
        }else {
            storageUtils.removeUser();
            memoryUtils.user = {};
            await reqLogOut();
            this.props.history.replace("/login");
        }
    };


    showInfo = () => {
        this.setState({
            disable: true,
            InfoText: '个人信息',
        });
    };

    showInfo1 = () => {
        this.setState({
            disable22: true,
            InfoText1: '个人信息',
        });
    };

    showPassword = async () => {
        this.setState({
            open: true,
            ModalText: '密码修改',
        });
    };

    showPassword1 = async () => {
        this.setState({
            open1: true,
            ModalText1: '密码修改',
        });
    };

    handleCancel = () => {
        this.setState({
            disable: false,
            open: false,
            disable22: false,
            open1: false,
        });
    };

    //修改教师密码
    handleSubmit = async (e) => {
        e.preventDefault();
        const values = this.form1Ref.getForm1Value();
        if (this.state.ModalText === '密码修改') {
            let loginData = new FormData();
            loginData.append("oldPwd", values.oldPwd);
            loginData.append("newPwd", values.newPwd);
            const result = await reqPwdTeacher(loginData);
            if (result.code === '000000') {
                message.success("修改成功,请重新登录");
                storageUtils.removeUser();
                memoryUtils.user = {};
                await reqLogOut();
                this.props.history.replace("/login");
            } else {
                message.error(result.data.msg);
            }
        }

    };

    //修改admin密码
    handleSubmit1 = async (e) => {
        e.preventDefault();
        const values = this.form4Ref.getForm4Value();
        if (this.state.ModalText1 === '密码修改') {
            if (values != undefined) {
                let loginData = new FormData();
                const adminpwd = {
                    pwd: '',
                }
                adminpwd.pwd = values.pwd
                const code = values.code
                loginData.append("pwd", adminpwd.pwd);
                loginData.append('code', code)

                const result = await reqEditAdminPwd(loginData, code);
                if (result.code === '000000') {
                    message.success("修改成功,请重新登录");
                    storageUtils.removeUser();
                    memoryUtils.user = {};
                    await reqLogOut();
                    this.props.history.replace("/login");
                } else {
                    message.error(result.data.msg);
                }
            }else{
                message.error('请输入必填信息')
            }

        }

    };

    infoSubmit = async (event) => {
        //组织表单的默认行为
        event.preventDefault();
        //对所有表单字段进行校验
        const values = this.form2Ref.getForm2Value();
        if (this.state.InfoText === '个人信息') {
            const result = await reqEditTeacher(values.departmentId, values.id, values);
            if (result.code === '000000') {
                message.success("修改成功");
                this.setState({
                    disable: false
                });
            } else {
                message.error(result.data.msg);
            }
        }

    };

    infoSubmit3 = async (event) => {
        //组织表单的默认行为
        event.preventDefault();
        //对所有表单字段进行校验
        const values = this.form3Ref.getForm3Value();
        if(values != undefined){
            const admin = {
                email: '',
                id: '',
                name: '',
                mobile: '',
                userName: ''
            }
            admin.email = values.email;
            admin.id = values.id;
            admin.name = values.name;
            admin.mobile = values.mobile;
            admin.userName = values.userName;
            const code = values.code;
            if (this.state.InfoText1 === '个人信息') {
                const result = await reqEditadmin(admin, code);
                if (result.code === '000000') {
                    message.success("修改成功");
                    this.setState({
                        disable22: false
                    });
                } else {
                    message.error(result.data.msg);
                }
            }
        }else{
            message.error('请输入必填信息')
        }

    };

    getMsgList = async (data) => {
        const result = await reqMsgList(data);
        const messageList = result.data;
        if (result.code === '000000') {
            this.setState({
                messageList: messageList.rows
            });
            let count = 0;
            for (let i = 0; i < this.state.messageList.length; i++) {
                let  status = this.state.messageList[i].status;
                if(status){
                    count++;
                }
            }
            this.setState({
                count: count
            })
        } else {
            message.error(result.msg);
        }
    };
    readMsg = async (e) => {
        e.persist();
        let type = sessionStorage.getItem("testing");
        if (type==="ing") {   //处于当前页面
            sessionStorage.setItem("leavePage","none");
            document.getElementById("submit").click();
        }else {
            const count = this.state.count;
            if (count > 0) {
                const msgList = this.state.messageList;
                let ids = [];
                for (let i = 0; i < msgList.length; i++) {
                    ids.push(msgList[i].messageId)
                }
                const result = await reqReadMsg(ids.toString());
                if (result.code === '000000') {
                    message.success("全部消息已读");
                    this.getMsgList({
                        page: 1,
                        size: 10
                    });
                } else {
                    message.error(result.msg)
                }
            }
            this.props.history.push("/question");
        }
    };
    deleteMsg = async (e) => {
        e.persist();
        const msgList = this.state.messageList;
        if (msgList.length > 0) {
            const result = await reqDeleteMsg();
            if (result.code === '000000') {
                message.success("清除成功");
                this.setState({
                    badge: false
                });
                this.getMsgList({
                    page: 1,
                    size: 10
                });
            } else {
                message.error(result.msg)
            }
        } else {
            message.info("无数据")
        }
    };

    toPage = (url) =>{
        let type = sessionStorage.getItem("testing");
        if (type==="ing") {   //处于当前页面
            sessionStorage.setItem("leavePage","none");
            document.getElementById("submit").click();
        }else {
            this.props.history.replace(url);
        }
    };

    componentDidMount = async () => {
        const result = await reqCurrent();
        this.setState({
            user: result.data,
            authority: memoryUtils.user.authority
        });
        this.getMsgList({
            page: 1,
            size: 10
        });
    };

    render() {
        const {open, open1,ModalText,ModalText1,confirmLoading, InfoText,InfoText1, disable,disable22, user, messageList, count} = this.state;
        const msgList = (
            <div className={"message_on"}>
                <div className="message_head">
                    我的消息
                    <a className="message_clear" onClick={this.deleteMsg.bind(this)}>清空消息</a>
                </div>
                <div className="message_body">
                    <List
                        itemLayout="horizontal"
                        dataSource={messageList}
                        renderItem={item => (
                            <List.Item>
                                <a className="message-a"
                                   onClick={this.readMsg.bind(this)}>
                                    <div className="thumb">
                                        <Avatar shape="square" src={item.avatar} size={50}/>
                                        <i className={item.status ? '' : 'span_no'}/>
                                        <div style={{textAlign: "center"}}>{item.name}</div>
                                    </div>
                                    <div className="info">
                                        <h5>{item.message}</h5>
                                        <p>{item.title}</p>
                                        <p className="time-feedback">{moment(item.createTime).format("YYYY-MM-DD HH:mm:ss")}</p>
                                    </div>
                                </a>
                            </List.Item>
                        )}
                    />
                </div>
            </div>
        );
        const menu = (
            <div className="center_on">
                <div className="center_head">
                    {user.userName}
                </div>
                <div className="center_body" style={{display: this.state.authority === "STUDENT" ? 'block' : 'none'}}>
                    <a onClick={this.toPage.bind(this,'/study')} className="center_link">学习情况</a>
                </div>
                <div className="center_body" style={{display: this.state.authority === "STUDENT" ? 'none' : 'block'}}>
                    <a onClick={this.toPage.bind(this,'/student')} className="center_link">管理员</a>
                </div>
                <div className="center_body" style={{display: this.state.authority === "TEACHER" ? 'block' : 'none'}}>
                    <a onClick={this.showInfo} className="center_link">个人信息</a>
                </div>
                <div className="center_body" style={{ display: this.state.authority === "ADMIN" ? 'block' : 'none' }}>
                    <a onClick={this.showInfo1} className="center_link">个人信息</a>
                </div>
                <div className="center_body" style={{display: this.state.authority === "STUDENT" ? 'block' : 'none'}}>
                    <a onClick={this.toPage.bind(this,'/info')} className="center_link">个人信息</a>
                </div>
                {/* 教师端密码修改 */}
                <div className="center_body" style={{display: this.state.authority === "TEACHER" ? 'block' : 'none'}}>
                    <a onClick={this.showPassword} className="center_link">密码修改</a>
                </div>
                {/* 管理员端密码修改 */}
                <div className="center_body" style={{ display: this.state.authority === "ADMIN" ? 'block' : 'none' }}>
                    <a onClick={this.showPassword1} className="center_link">密码修改</a>
                </div>
                {/* 学生密码修改 */}
                <div className="center_body" style={{display: this.state.authority === "STUDENT" ? 'block' : 'none'}}>
                    <a onClick={this.toPage.bind(this,'/password')} className="center_link">密码修改</a>
                </div>
                <div className="center_body">
                    <a onClick={this.logOut} className="center_link">退出登录</a>
                </div>
            </div>
        );
        return (
            <div className="header">
                <div className="logo">
                    <a onClick={this.toPage.bind(this,"/")}>
                        <img src={require('./images/header-logo.png')}/>
                    </a>
                </div>
                <div className="logo_t" style={{display:"none"}}>
                    <img src={require('./images/logo.png')} style={{width: 400,marginTop: 5}}/>
                </div>
                <div className="nav_right">
                    <ul>
                        <Dropdown overlay={msgList} >
                            <li>
                                <div className="icon_bell">

                                    <img src={require('./images/icon-bell-o.png')}/>
                                    <span className={count > 0 ? '' : 'span_no'}>{count}</span>

                                </div>
                                <div className="center_name">消息</div>
                            </li>
                        </Dropdown>
                        <Dropdown overlay={menu}>
                            <li>
                                <div className="head_img">
                                    <img
                                        src={user.avatar ? global.constant.uploadImage + user.avatar : require("../../assets/images/head.png")}/>
                                </div>
                                <div className="center_name">{user.name}</div>
                            </li>
                        </Dropdown>
                    </ul>
                </div>
                <Modal className='head_modal' title={ModalText}
                       footer={[<Button key="confirm" className="" type="primary" size="large"
                                        onClick={this.handleSubmit}>确认</Button>,
                           <Button key="cancel" className="" type="primary" size="large"
                                   onClick={this.handleCancel}>取消</Button>]}
                       visible={open} confirmLoading={confirmLoading} destroyOnClose='true' onCancel={this.handleCancel}>
                    <Form1 wrappedComponentRef={(form) => this.form1Ref = form}>Form1</Form1>
                </Modal>
                <Modal className='head_modal' title={InfoText}
                       footer={[<Button key="confirm" className="" type="primary" size="large"
                                        onClick={this.infoSubmit}>确认</Button>,
                           <Button key="cancel" className="" type="primary" size="large"
                                   onClick={this.handleCancel}>取消</Button>]}
                       visible={disable} destroyOnClose='true' onCancel={this.handleCancel}>
                    <Form2 wrappedComponentRef={(form) => this.form2Ref = form}>Form2</Form2>
                </Modal>
                <Modal className='head_modal' title={InfoText1}
                    footer={[<Button key="confirm" className="" type="primary" size="large"
                        onClick={this.infoSubmit3}>确认</Button>,
                    <Button key="cancel" className="" type="primary" size="large"
                        onClick={this.handleCancel}>取消</Button>]}
                    visible={disable22} destroyOnClose='true' onCancel={this.handleCancel}>
                    <Form3 wrappedComponentRef={(form) => this.form3Ref = form}>Form3</Form3>
                </Modal>
                <Modal className='head_modal' title={ModalText1}
                    footer={[<Button key="confirm" className="" type="primary" size="large"
                        onClick={this.handleSubmit1}>确认</Button>,
                    <Button key="cancel" className="" type="primary" size="large"
                        onClick={this.handleCancel}>取消</Button>]}
                    visible={open1} confirmLoading={confirmLoading} destroyOnClose='true' onCancel={this.handleCancel}>
                    <Form4 wrappedComponentRef={(form) => this.form4Ref = form}>Form4</Form4>
                </Modal>
            </div>
        )
    }
}

export default withRouter(Header);
